/**
 * Shared visual badges for a coach-client relationship status. Used by the coach-facing client card,
 * the student's My Coach page, and the guardian's child card, so the label/color for each status
 * stays consistent. Non-active relationships are visible but gated until agreements are signed.
 */
export const RELATIONSHIP_STATUS_BADGE = {
  pending: {
    label: 'Pending acceptance',
    cls: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
  },
  pending_guardian_approval: {
    label: 'Awaiting guardian approval',
    cls: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
  },
  pending_agreements: {
    label: 'Agreements required',
    cls: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
  },
  active: {
    label: 'Active',
    cls: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300'
  }
}

/**
 * Guardian-facing variant: the guardian is the one who approves, so the awaiting-approval label reads
 * "Awaiting your approval" rather than "Awaiting guardian approval".
 */
export const GUARDIAN_RELATIONSHIP_STATUS_BADGE = {
  ...RELATIONSHIP_STATUS_BADGE,
  pending_guardian_approval: {
    ...RELATIONSHIP_STATUS_BADGE.pending_guardian_approval,
    label: 'Awaiting your approval'
  }
}
